import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useGetSelectedTariffBySlugQuery } from '@/app/Purchase/api/ordersApi';
import LegalModalContainer from '../components/LegalModal';
import OrderSummary from '../components/orders/OrderSummary';
import TermsCheckbox from '../components/orders/TermsCheckbox';
import OrderActions from '../components/orders/OrderActions';
import type { IntroCodeData, OrderProps } from '../types/purchaseTypes';

function Order({ isMemberStep = false }: OrderProps) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isLegalModalOpen, setIsLegalModalOpen] = useState(false);
  const [agreedWithTerms, setAgreedWithTerms] = useState(false);
  const [isAgreedWithTermsError, setIsAgreedWithTermsError] = useState(false);
  const [introCodeData, setIntroCodeData] = useState<IntroCodeData | null>(null);

  const { 
    data: selectedTariff, 
    isFetching: isLoadingTariffData,
    error,
    isError 
  } = useGetSelectedTariffBySlugQuery(
    {
      tariff_slug: searchParams.get('t') || searchParams.get('r'),
      weekly_updates: Number(searchParams.get('wu')) || null
    },
    { skip: !searchParams.has('t') && !searchParams.has('r') }
  );

  // Redirect to 404 page if error occurs
  useEffect(() => {
    if (isError || error) {
      navigate('/errors/404', { replace: true });
    }
  }, [isError, error, navigate]);

  const handleIntroCodeSuccess = (data: IntroCodeData) => {
    setIntroCodeData(data);
  };

  // Don't render content if error exists (redirecting to 404)
  if (isError || error) {
    return null;
  }

  return (
    <div className="text-start">
      <LegalModalContainer
        show={isLegalModalOpen}
        setShow={setIsLegalModalOpen}
      />

      <OrderSummary
        selectedTariff={selectedTariff}
        introCodeData={introCodeData}
        isLoadingTariffData={isLoadingTariffData}
      />

      <TermsCheckbox
        agreedWithTerms={agreedWithTerms}
        setAgreedWithTerms={setAgreedWithTerms}
        isError={isAgreedWithTermsError}
        setIsError={setIsAgreedWithTermsError}
      />

      <OrderActions
        isMemberStep={isMemberStep}
        searchParams={searchParams}
        selectedTariff={selectedTariff}
        introCodeData={introCodeData}
        setIsLegalModalOpen={setIsLegalModalOpen}
        agreedWithTerms={agreedWithTerms}
        setIsAgreedWithTermsError={setIsAgreedWithTermsError}
        navigate={navigate}
        onIntroCodeSuccess={handleIntroCodeSuccess}
      />
    </div>
  );
};

export default Order;
